export const SBL = 'SBL';
export const BLE_STACK = 'BLE';

export const getIsPackageTypeSbl = (packageType) => {
    return packageType === SBL;
};

export const getIsPackageTypeBleStack = (packageType) => {
    return packageType === BLE_STACK;
};
